import React from 'react';
import styled from 'styled-components';

interface GridAreaConfigure {
  readonly children: React.ReactNode;
}

export function GridAreaConfigure({children}: GridAreaConfigure): JSX.Element {
  return <GridAreaConfigureWrapper>{children}</GridAreaConfigureWrapper>;
}

const GridAreaConfigureWrapper = styled.div`
  display: flex;
  grid-area: configure;
  justify-content: center;
  margin-top: ${(props) => props.theme.internal.size.dynamic0150};
  padding: 0 ${(props) => props.theme.internal.size.grid001};

  &:empty {
    margin-top: 0;
  }

  @media (min-width: ${(props) => props.theme.internal.Breakpoints.b960}px) {
    display: none;
  }
`;
